module.exports = __webpack_public_path__ + "img/sf2.2035fc4d.png";